import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import _ from 'lodash';
import { UtilsService } from '../../../../services/utils.service';
import { TranslateService } from '@ngx-translate/core';

export interface Model {
    title: string;
    data: any;
}

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.css', '../../myreports.component.css']
})
export class FeatureComponent extends DialogComponent<Model, any> implements OnInit {
    
    title: string;
    data: any;
    features: any = [];
    currentUser: any;
    isLicense: boolean = false;
    ruid: string;

    columns = [
        {
            name: 'featureDescription',
            desc: this.translate.instant('reports.featuresC.packageFeature'),
            tooltip: '',
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'expireDate',
            desc: this.translate.instant('reports.featuresC.expiration'),
            tooltip: this.translate.instant('reports.featuresC.expDate'),
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'sessions',
            desc: this.translate.instant('reports.featuresC.sessions'),
            tooltip: this.translate.instant('reports.featuresC.userAm'),
            sorter: this.utilService.numberStringTableSorterFactory,
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'duration',
            desc: this.translate.instant('reports.featuresC.totalH'),
            tooltip: this.translate.instant('reports.featuresC.totalTime'),
            sorter: this.utilService.durationTableSorterFactory,
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'averageDuration',
            desc: this.translate.instant('reports.featuresC.avg'),
            tooltip: this.translate.instant('reports.featuresC.avgSession'),
            sorter: this.utilService.durationTableSorterFactory,
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'denials',
            desc: this.translate.instant('reports.featuresC.denials'),
            tooltip: this.translate.instant('reports.featuresC.total'),
            sorter: this.utilService.numberStringTableSorterFactory,
            sort: 'asc',
            isCurrent: false
        },
        {
            name: 'denialRate',
            desc: this.translate.instant('reports.featuresC.denialP'),
            tooltip: this.translate.instant('reports.featuresC.denial'),
            sorter: this.utilService.numberStringTableSorterFactory,
            sort: 'asc',
            isCurrent: false
        }
    ];

    limitedColumns = [this.columns[0], this.columns[1]];

    constructor(
        dialogService: DialogService,
        private utilService: UtilsService,
        private translate: TranslateService
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.features = this.data.features;
        this.isLicense = this.data.isLicense;
        this.currentUser = this.data.currentUser;
        this.ruid = this.data.ruid;
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    sortCols(name) {
        const column = _.find(this.columns, { name });
        _.each(this.columns, column => {
            column.isCurrent = false;
        });
        column.isCurrent = true;

        const sorter = column.sorter ? column.sorter(name) : name;
        const order = column.sort;
        this.features = _.orderBy(this.features, sorter, order);

        _.each(this.features, feature => {
            if (feature.components.length > 1) {
                feature.components = _.orderBy(
                    feature.components,
                    sorter,
                    order
                );
            }
        });

        if (order === 'asc') {
            column.sort = 'desc';
        } else {
            column.sort = 'asc';
        }
    }

    sortingStyle(column) {
        return {
            'sorting-up': column.isCurrent && column.sort === 'asc',
            'sorting-down': column.isCurrent && column.sort === 'desc'
        };
    }

    visibleColumns() {
        return this.isFullReportAllowed() ? this.columns : this.limitedColumns;
    }

    isFullReportAllowed() {
        return this.currentUser && this.currentUser.paid || this.ruid === 'demo';
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/zoomView/features/features.component.ts